import { render, staticRenderFns } from "./CapituloTrecePage.vue?vue&type=template&id=526b6941"
import script from "./CapituloTrecePage.js?vue&type=script&lang=js&external"
export * from "./CapituloTrecePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports